import { createContext, use } from "react";

import type { ApiClient } from "./api-client";
import { apiClient } from "./api-client";

/**
 * The HTTP client, reachable from components.
 *
 * Query factories take a client rather than importing the singleton, so a
 * test can hand a screen a stubbed transport and still exercise the real
 * query keys, the real contract validation and the real refresh logic. The
 * default is the application's own client, so nothing has to be wired up for
 * the app to work.
 */
export const ApiClientContext = createContext<ApiClient>(apiClient);

export function useApiClient(): ApiClient {
  return use(ApiClientContext);
}
